(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pp-ratgeber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Größen-Finder über der Maßtabelle: Maße des Geschenks eingeben → passende Zeilen markieren (mind. 1 cm Luft je Maß,
    // Geschenk darf gedreht werden). Die Tabelle selbst bleibt unverändert lesbar.
    // 23.10.2026 (A-0434): Haken „Kartonmaße“ rechnet ohne Luft. ?masse=… (Link im Maß-Hinweis der Suche, snippets/pp-such-ergebnis) füllt die
    // Felder vor, setzt den Haken und rollt zum Finder – aus der Adresse werden nur Zahlen übernommen, der Text selbst wird nie angezeigt.
    var ZUGABE = 1;
    function zahl(s) { return parseFloat(String(s).replace(',', '.')); }
    function masse(text) {
      var re = /(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)\s*[×x]\s*(\d+(?:[.,]\d+)?)/g, m, letzte = null;
      while ((m = re.exec(text))) letzte = m;
      if (!letzte) return null;
      return { d: [zahl(letzte[1]), zahl(letzte[2]), zahl(letzte[3])].sort(function (a, b) { return b - a; }), text: letzte[0] };
    }
    // Suche „60 x 25 x 20“ → ['60', '25', '20'], „karton 20x20“ → ['20', '20', ''], „200 x 150 mm“ → ['20', '15', ''] (cm, Komma statt Punkt)
    function ausAdresse() {
      var q = null;
      try { q = new URLSearchParams(location.search).get('masse'); } catch (e) { return null; }
      if (!q) return null;
      var m = /(\d+(?:[.,]\d+)?)\s*(?:cm|mm)?\s*[×x*]\s*(\d+(?:[.,]\d+)?)(?:\s*(?:cm|mm)?\s*[×x*]\s*(\d+(?:[.,]\d+)?))?/i.exec(q);
      if (!m) return null;
      var mm = /\d\s*mm\b/i.test(q);
      return [m[1], m[2], m[3]].map(function (s) {
        if (!s) return '';
        var x = zahl(s); if (mm) x = x / 10;
        return x > 0 && x < 1000 ? String(Math.round(x * 10) / 10).replace('.', ',') : '';
      });
    }
    function start(wurzel) {
      var t = wurzel.querySelector('table.pp-masstabelle');
      if (!t || t.getAttribute('data-pp-finder')) return;
      t.setAttribute('data-pp-finder', '1');
      var zeilen = [];
      Array.prototype.forEach.call(t.tBodies[0].rows, function (tr) {
        var m = tr.cells[1] ? masse(tr.cells[1].textContent) : null;
        if (m) zeilen.push({ tr: tr, d: m.d, v: m.d[0] * m.d[1] * m.d[2], name: tr.cells[0].textContent.trim(), masse: m.text });
      });
      if (!zeilen.length) return;
      var box = document.createElement('div');
      box.className = 'pp-finder';
      box.id = 'groessen-finder';
      var namen = ['Länge', 'Breite', 'Höhe'];
      box.innerHTML = '<p class="pp-finder__titel"><strong>Größen-Finder:</strong> Geben Sie die Maße Ihres Geschenks in cm ein – passende Kartons werden in der Tabelle markiert. Wir rechnen je Maß 1 cm Luft dazu, damit es gut hineinpasst.</p>' +
        '<p class="pp-finder__herkunft" hidden></p>' +
        '<div class="pp-finder__felder">' + namen.map(function (n) { return '<label><span>' + n + '</span><input type="text" inputmode="decimal" autocomplete="off" placeholder="cm" aria-label="' + n + ' in cm"></label>'; }).join('<span class="pp-finder__mal" aria-hidden="true">×</span>') +
        '</div>' +
        '<label class="pp-finder__karton"><input type="checkbox"> Das sind schon Kartonmaße (innen) – ohne Luft rechnen</label>' +
        '<p class="pp-finder__ergebnis" aria-live="polite"></p>' +
        '<div class="pp-finder__aktionen" hidden><label class="pp-finder__nur"><input type="checkbox"> nur passende Kartons zeigen</label>' +
        '<button type="button" class="pp-finder__leeren">Eingaben löschen</button></div>';
      var rahmen = t.parentNode && t.parentNode.classList.contains('pp-tabelle-rahmen') ? t.parentNode : t;
      rahmen.parentNode.insertBefore(box, rahmen);
      var felder = Array.prototype.slice.call(box.querySelectorAll('.pp-finder__felder input'));
      var ergebnis = box.querySelector('.pp-finder__ergebnis');
      var aktionen = box.querySelector('.pp-finder__aktionen');
      var nurBox = box.querySelector('.pp-finder__nur'), nur = nurBox.querySelector('input');
      var leeren = box.querySelector('.pp-finder__leeren');
      var karton = box.querySelector('.pp-finder__karton input'), herkunft = box.querySelector('.pp-finder__herkunft');
      function zuruecksetzen() {
        zeilen.forEach(function (z) { z.tr.classList.remove('pp-passt', 'pp-passt-best', 'pp-passt-nicht'); });
        t.classList.remove('pp-nur-passende');
        nurBox.hidden = true;
      }
      function pruefen() {
        var werte = felder.map(function (f) { return zahl(f.value); });
        aktionen.hidden = !felder.some(function (f) { return f.value.trim() !== ''; });
        var leer = [];
        werte.forEach(function (x, i) { if (!(x > 0)) leer.push(i); });
        if (leer.length) {
          zuruecksetzen();
          // genau ein Feld noch leer (z. B. „karton 20x20“ aus der Suche): sagen, was fehlt
          ergebnis.textContent = leer.length === 1 && felder[leer[0]].value.trim() === '' ? 'Noch die ' + namen[leer[0]] + ' eingeben – dann markiert der Finder die passenden Kartons.' : '';
          return;
        }
        var luft = karton.checked ? 0 : ZUGABE;
        var g = werte.slice().sort(function (a, b) { return b - a; }).map(function (x) { return x + luft; });
        var passend = zeilen.filter(function (z) { return z.d[0] >= g[0] && z.d[1] >= g[1] && z.d[2] >= g[2]; })
          .sort(function (a, b) { return a.v - b.v; });
        zeilen.forEach(function (z) {
          var p = passend.indexOf(z) > -1;
          z.tr.classList.toggle('pp-passt', p);
          z.tr.classList.toggle('pp-passt-nicht', !p);
          z.tr.classList.remove('pp-passt-best');
        });
        if (passend.length) {
          passend[0].tr.classList.add('pp-passt-best');
          ergebnis.innerHTML = '<strong>' + passend.length + (passend.length === 1 ? ' Karton passt' : ' Kartons passen') + '</strong> (' + (luft ? 'mit mindestens 1 cm Luft je Maß' : 'innen mindestens so groß wie Ihre Maße') + '). Am knappsten: <strong>' +
            passend[0].name.replace(/</g, '&lt;') + '</strong> (' + passend[0].masse + ' cm).';
          nurBox.hidden = false;
        } else {
          ergebnis.textContent = 'Kein Karton aus der Tabelle ist groß genug. Rufen Sie uns an – wir suchen gern eine Lösung.';
          nurBox.hidden = true;
        }
        t.classList.toggle('pp-nur-passende', nur.checked && passend.length > 0);
      }
      felder.forEach(function (f) { f.addEventListener('input', pruefen); });
      nur.addEventListener('change', pruefen);
      karton.addEventListener('change', pruefen);
      leeren.addEventListener('click', function () { felder.forEach(function (f) { f.value = ''; }); nur.checked = false; karton.checked = false; herkunft.hidden = true; pruefen(); felder[0].focus(); });
      var vor = ausAdresse();
      if (vor) {
        vor.forEach(function (w, i) { felder[i].value = w; });
        karton.checked = true;
        herkunft.textContent = 'Aus Ihrer Suche übernommen: ' + vor.filter(Boolean).join(' × ') + ' cm, als Kartonmaße gerechnet. Sind es die Maße Ihres Geschenks, nehmen Sie den Haken unten heraus.';
        herkunft.hidden = false;
        pruefen();
        var rollen = function () { box.scrollIntoView({ block: 'start' }); };
        rollen();
        if (document.readyState !== 'complete') window.addEventListener('load', rollen, { once: true });
      }
    }
    function alle() { Array.prototype.forEach.call(document.querySelectorAll('[data-pp-rg]'), start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
    document.addEventListener('shopify:section:load', alle);
  })();

  } catch(e) { console.error(e); }
})();
})();
